import { useState } from "react";
import { Outlet } from "react-router-dom";

const getPreviousMonthYear = () => {
  const date = new Date();
  date.setDate(1); // avoid month rollover issues (e.g. 31st)
  date.setMonth(date.getMonth() - 1);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
};

const ComplianceRoot = () => {
  const [monthYear, setMonthYear] = useState(getPreviousMonthYear());

  return <Outlet context={{ monthYear, setMonthYear }} />;
};

export default ComplianceRoot;
